import React, { useState, useEffect } from 'react'
import {
    useManageAppDimensionRowsMutation,
    useAddNewAppDimensionRowsMutation,
} from '../../Redux/Admin_Tasks/DimensionSlice/ManageDimensionSLice'
import { FoundationsButton } from '../../GenericComponents/button'
import { FoundationsInput } from '../../GenericComponents/input'
import { FoundationsCheckBox } from '../../GenericComponents/checkbox'
import FoundationsSelect from '../../GenericComponents/select'
import { FoundationsGenericToaster } from '../../GenericComponents/FoundationsGenericToaster'
import { useTitleContext } from '../../Hooks/useTitleContext'

declare let window: any
const UnicornApp = window.unicornInstance as any

const AddNewAppDimensionRows: React.FC = () => {
    const { setTitle } = useTitleContext()
    setTitle('Dimension Manager')

    const [GuidValue, setGuidValue] = useState<string | null>(null)
    const [formData, setFormData] = useState<any>({})
    const [isSaving, setIsSaving] = useState(false)

    useEffect(() => {
        const hash = window.location.hash
        const queryIndex = hash.indexOf('?')

        if (queryIndex !== -1) {
            const queryString = hash.substring(queryIndex + 1)
            const queryParams = new URLSearchParams(queryString)
            const guidFromUrl = queryParams.get('Guid')
            setGuidValue(guidFromUrl)
        }
    }, [])

    const [appDimensionRows, { data }] = useManageAppDimensionRowsMutation()
    useEffect(() => {
        if (GuidValue) {
            appDimensionRows({
                AppDimensionGuid: GuidValue,
                AppDimensionRowId: -99999,
            })
                .unwrap()
                .catch((error) => {
                    console.error('API call failed:', error)
                })
        }
    }, [GuidValue, appDimensionRows])
    const [AddNewAppDimensionRows, {}] = useAddNewAppDimensionRowsMutation()
    const [errors, setErrors] = useState<Record<string, string>>({})
    //const [developerMessage, setDeveloperMessage] = useState('')
    const [generalMessage, setGeneralMessage] = useState('')
    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value, type } = e.target
        if (type === 'select-one') {
            setFormData((prevData: any) => ({
                ...prevData,
                [name]: value,
            }))
        } else if (type === 'checkbox') {
            const target = e.target as HTMLInputElement
            setFormData((prevData: any) => ({
                ...prevData,
                [name]: target.checked,
            }))
        } else {
            setFormData((prevData: any) => ({
                ...prevData,
                [name]: value,
            }))
        }

        setGeneralMessage('')

        const fieldDescription =
            data.AppDimensionFields.find((f: any) => f.FieldName === name)?.FieldDescription || name //FP-10810 : Error message should include FieldDescription, not FieldName
        const maxLength =
            data.AppDimensionFields.find((f: any) => f.FieldName === name)?.FieldLength || 2048

        if (value.length == maxLength) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                [fieldDescription]: `${fieldDescription} cannot be more than ${maxLength} characters`,
            }))
        } else {
            if (errors[name as keyof typeof errors]) {
                setErrors((prevErrors) => {
                    const newErrors = { ...prevErrors }
                    delete newErrors[name as keyof typeof errors]
                    return newErrors
                })
            }
        }
    }

    const handleSave = () => {
        if (isSaving) return
        setIsSaving(true)

        const updatedData = { ...formData }
        const newErrors: { [key: string]: string } = {}
        //let devMessage = ''
        let keys: string[] = []
        AddNewAppDimensionRows({
            AppDimensionGuid: GuidValue !== null ? GuidValue.toString() : '',
            AppDimensionRowId: -9999,
            AppDimensionRow: JSON.stringify(updatedData),
        })
            .unwrap()
            .then((response) => {
                if (response && response.MessageResults) {
                    if (response.MessageResults[0].HelpMessage === 0) {
                        FoundationsGenericToaster('success', response.MessageResults[0].Message)

                        setTimeout(() => {
                            window.location.hash = `#appdimensions/rows?Guid=${GuidValue}`
                        }, 300)
                    } else {
                        response.MessageResults.forEach((result: any) => {
                            const { Field, Message, DeveloperMessage } = result

                            if (Message) {
                                newErrors[Field] = Message
                                //devMessage = DeveloperMessage || ''
                            }

                            keys.push(Field)
                        })
                        setErrors(newErrors)
                        //setDeveloperMessage(devMessage)
                        setGeneralMessage('Please correct the errors below and try again.')
                        setIsSaving(false)
                    }
                }
            })
            .catch((error) => {
                console.error('Save failed:', error)
                setIsSaving(false)
            })
    }
    const handleCancel = () => {
        window.location.hash = `#appdimensions/rows?Guid=${GuidValue}`
    }

    if (data) {
        return (
            <>
                <div id="dimension-manager">
                    <div className="">
                        <div className="content">
                            <div className="float-right margin-top-small">
                                <a id="link_backto_admin_tasks" href={`#AdminTasks`}>
                                    &laquo; Back to Admin Tasks
                                </a>
                            </div>
                            <div className="header">Manage Dimensions</div>
                            <br />
                            <h5 className="float-left" id="DimAppName">
                                Add {data.AppDimension.Name} New Row
                            </h5>
                            <div className="float-right margin-top-small">
                                <a
                                    id="dimension"
                                    className="back-to-dimensions"
                                    href={`#appdimensions`}
                                >
                                    &laquo; Back to Dimensions
                                </a>
                                <span className="admin-menu-divider">&bull;</span>
                                <a
                                    className="go-to-manage-rows"
                                    id="manageRow"
                                    href={`#appdimensions/rows?Guid=${GuidValue}`}
                                    data-guid={GuidValue}
                                >
                                    &laquo; Back to Manage Rows
                                </a>
                            </div>
                            <div className="padding-bottom-medium clear-both"></div>
                            <div className="form-horizontal voffset4 center-block" role="form">
                                {generalMessage && (
                                    <p
                                        id="pDisplayErrorEditRow"
                                        className="margin-bottom-large  show"
                                    >
                                        <div className="status-box-error mb-3 text-left ">
                                            {generalMessage}
                                        </div>
                                    </p>
                                )}

                                {data.AppDimensionFields.map((field: any, index: any) => (
                                    <div className="form-group row" key={index}>
                                        {field.PrimaryKey === 'N' && field.ViewableInUI === 'Y' && (
                                            <>
                                                <label className={'col-sm-3 text-right'}>
                                                    {field.FieldDescription}:
                                                </label>
                                                <div
                                                    className={'col-sm-5'}
                                                    data-switch={field.FieldType}
                                                >
                                                    {field.FieldType === 1 && (
                                                        <>
                                                            <FoundationsInput
                                                                type="text"
                                                                inputClasses="form-control inputText-val"
                                                                id={field.FieldName}
                                                                name={field.FieldName}
                                                                placeHolder=""
                                                                value={
                                                                    formData[field.FieldName] || ''
                                                                }
                                                                maxLength={
                                                                    field.FieldLength
                                                                        ? field.FieldLength
                                                                        : '2048'
                                                                }
                                                                inputStyle={{
                                                                    height: '35px',
                                                                    width: '720px',
                                                                }}
                                                                onInput={handleInputChange}
                                                            />
                                                            <span
                                                                id={`${field.FieldName}_FieldError`}
                                                                style={{
                                                                    display: 'none',
                                                                    color: 'red',
                                                                }}
                                                            >
                                                                {field.FieldDescription} cannot be
                                                                more than{' '}
                                                                {field.FieldLength
                                                                    ? field.FieldLength
                                                                    : '2048'}{' '}
                                                                characters
                                                            </span>
                                                        </>
                                                    )}

                                                    {field.FieldType === 5 && (
                                                        <FoundationsSelect
                                                            id={field.FieldName}
                                                            customStyles={{
                                                                height: '35px',
                                                                width: '720px',
                                                            }}
                                                            name={field.FieldName}
                                                            value={formData[field.FieldName] || ''}
                                                            onChange={handleInputChange}
                                                        >
                                                            <option value="" selected disabled>
                                                                - choose a value -
                                                            </option>
                                                            {field.PulldownValues.map(
                                                                (value: any, i: any) => (
                                                                    <option
                                                                        key={i}
                                                                        value={value.Value}
                                                                    >
                                                                        {value.Value}
                                                                    </option>
                                                                )
                                                            )}
                                                        </FoundationsSelect>
                                                    )}

                                                    {field.FieldType === 3 && (
                                                        <FoundationsInput
                                                            type="number"
                                                            inputClasses="form-control"
                                                            id={field.FieldName}
                                                            name={field.FieldName}
                                                            placeHolder=""
                                                            value={formData[field.FieldName] || ''}
                                                            //step="0.01"
                                                            //autoFocus
                                                            inputStyle={{
                                                                height: '35px',
                                                                width: '720px',
                                                            }}
                                                            onInput={handleInputChange}
                                                        />
                                                    )}

                                                    {field.FieldType === 6 && (
                                                        <div className="form-check form-check-inline">
                                                            <FoundationsCheckBox
                                                                inputClasses="form-check-input"
                                                                name={field.FieldName}
                                                                id={field.FieldName}
                                                                checked={
                                                                    formData[field.FieldName] ||
                                                                    false
                                                                }
                                                                onChange={(e) =>
                                                                    setFormData(
                                                                        (prevData: any) => ({
                                                                            ...prevData,
                                                                            [field.FieldName]:
                                                                                e.target.checked,
                                                                        })
                                                                    )
                                                                }
                                                            />
                                                        </div>
                                                    )}
                                                    {errors[field.FieldName] && (
                                                        <div
                                                            id={`valmsg_param_${field.FieldName}`}
                                                            className="field-validation-error"
                                                            style={{ color: 'red' }}
                                                        >
                                                            {errors[field.FieldName]}
                                                        </div>
                                                    )}
                                                </div>
                                            </>
                                        )}
                                    </div>
                                ))}

                                <div className="form-group voffset5 row">
                                    <div
                                        className="col-sm-offset-3 row"
                                        style={{ marginLeft: '25%' }}
                                    >
                                        <div className="col-sm-8">
                                            <FoundationsButton
                                                type="button"
                                                buttonClasses="btn btn-block app-button"
                                                id="SaveAppDimension"
                                                onClick={handleSave}
                                                disabled={isSaving}
                                            >
                                                Save
                                            </FoundationsButton>
                                        </div>
                                        <div className="col-sm-2">
                                            <FoundationsButton
                                                type="button"
                                                buttonClasses="btn btn-default app-button negative"
                                                id="CancelAppDimension"
                                                onClick={handleCancel}
                                            >
                                                Cancel
                                            </FoundationsButton>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}
export default AddNewAppDimensionRows
